export const datamap =[
  {
    "img": "../images/tallyprime/accounting.webp",    
    "heading": "Accounting, inventory, e-Invoicing, and more - All in One software",
    "highlight": "All in One software",
    "desc": "Take charge of your business effortlessly—streamline operations, enhance efficiency, and boost productivity. TallyPrime brings everything you need, from accounting and compliance to inventory, banking, and more, into one seamless platform to help you manage, optimize, and scale with ease.",
    "features": ["Accounting", "Banking", "Inventory", "Cash & Credit Management"],
    "reverse": false
  },
  {
    "img": "../images/tallyprime/connected-solution.webp",    
    "heading": "Simplify GST & banking with connected solution",
    "highlight": "connected solution",
    "desc": "Streamline your GST with TallyPrime's easy-to-use connected solution. Enjoy direct uploading of GSTR-1 and GSTR-3B, filing and signing GSTR-1, auto GST reconciliation, and generating e-invoices / e-way bills—all in one place. Additionally, leverage the connected solution for faster payment, simplify your banking records, and auto bank reconciliation.",
    "features": ["Direct Filing & Uploads", "Auto GST Reconciliation", "WhatsApp for Business", "Connected Banking"],
    "reverse": true
  },
  {
    "img": "../images/tallyprime/anywhere-anydevice.webp",    
    "heading": "Manage your business from anywhere, anytime",
    "highlight": "Manage your business from",
    "desc": "Stay connected to your business anytime, anywhere. Access your business reports online from any device, keeping you informed and in control, no matter where you are. Thinking about moving to the cloud? We’ve got you covered with affordable subscription options and flexible plans tailored to fit your business needs seamlessly.",
    "features": ["Online Report Access", "Online Data Consolidation", "Cloud Access to TallyPrime"],
    "reverse": false
  },
  {
    "img": "../images/tallyprime/gst-compliance-made-easy.webp",    
    "heading": "GST compliance made easy",
    "highlight": "GST",
    "desc": "Stay effortlessly compliant and focus on growing your business. Keep your business aligned with the latest regulations, ensuring accurate return filing and seamless tax compliance with TallyPrime’s built-in prevention, detection, and correction technology. In addition, you can effortlessly manage your TDS and TCS needs for your business.",
    "features": ["e-Invoicing", "Accurate GST returns", "e-Way Bills", "TCS/TDS"],
    "reverse": true
  },
  {
    "img": "../images/tallyprime/anywhere-anydevice.webp",    
    "heading": "Real-Time personalised reports for smarter decisions",
    "highlight": "personalised reports",
    "desc": "Get instant, personalised reports tailored to your business needs. Modify, add, or configure information to reports, the way it best suits you and access accurate data instantly. With a powerful dashboard, multiple report views and analytical options, you can easily compare, create different viewpoints to understand your business better and make informed decisions.",
    "features": ["Report Dashboard", "Personalised Reports", "Report Analytics"],
    "reverse": false
  }
];

export const featuresData = [
    {
      img: "../images/tallyprime/gst.svg",      
      title: "GST-compliant invoices in seconds",
      description:
        "Easily create, print and email professional invoices with TallyPrime. Configure details, add a logo, and personalize them to your needs. Generate GST invoices, export bills, e-Invoices, e-Way bills, and print MSME UDYAM numbers on invoices easily.",
    },
    {
      img: "../images/tallyprime/Sale-Purchase.svg",      
      title: "Flexible purchase and sales management",
      description:
        "Do you follow different sales and purchase cycle? TallyPrime seamlessly adapts to different purchase and sales cycles, whether order-based or direct transactions. Manage sales orders, debit/credit notes, and payments effortlessly while keeping your books up to date with complete flexibility.",
    },
    {
      img: "../images/tallyprime/manufacturing.svg",      
      title: "Multiple billing format",
      description:
        "TallyPrime supports different billing formats to suit your business needs. Whether you deal with products or services, TallyPrime ensures faster, error-free billing with the right format for every transaction.",
    },
    {
      img: "../images/tallyprime/multiple-billin.svg",      
      title: "Multi-currency support",
      description:
        "Record invoices, quotations, orders, accept payments and receive bills in foreign currencies. TallyPrime auto calculates forex gains/losses due to currency fluctuations, ensuring accurate financial adjustments.",
    },
    {
      img: "../images/tallyprime/pricelevels.svg",      
      title: "Multiple price levels",
      description:
        "Create different price levels for wholesalers, retailers, or customers and assign different price lists with quantity-based rates and discounts. Ensure faster, error-free billing by auto capturing price details with TallyPrime.",
    },
    {
      img: "../images/tallyprime/digital-payments.svg",      
      title: "Payment QR code and link on invoices",
      description:
        "Easily add QR codes and payment links for single invoices or in bulk for multiple invoices.",
    },
    {
      img: "../images/tallyprime/multi-company.svg",      
      title: "Multiple addresses for company and ledgers",
      description:
        "Create multiple addresses for your company and party ledgers and use them in invoices and reports as required.",
    },
  ];
  
  export const pricingData = [
    {
      colorClass:"graycolor",
      title:"Silver",
      subtitle:"Single user edition For Standalone PCs",
      price:"$ 630",
      gst: "(+ Tax)",
      btnLink:"/contact",
    },
    {
      colorClass: "goldcolor",
      title:"Gold",
      subtitle:"Unlimited multi-user edition For multiple PCs on LAN environment",
      price:"$ 1,890",
      gst:"(+ Tax)",
      btnLink:"/contact",
    },
  ];
  